module.exports = __webpack_public_path__ + "img/station_expanded_pin.96fce2a0.png";